import { createTheme as o } from "../../_mixins/use-theme.js";
import r from "../../_styles/common/light.js";
import t from "../../tooltip/styles/light.js";
function e() {
  return {
    toolbarIconColor: "rgba(255, 255, 255, .9)",
    toolbarColor: "rgba(0, 0, 0, .35)",
    toolbarBoxShadow: "none",
    toolbarBorderRadius: "24px"
  };
}
const n = o({
  name: "Image",
  common: r,
  peers: {
    Tooltip: t
  },
  self: e
});
export {
  n as imageLight
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/image/styles/light.js
// module id = 1655
// module chunks = 41